import type { State } from 'types/redux'
import { SHOWCASES } from '@disco/constants/FeatureTypes'
import {
  getIsTrial,
  isFeatureEnabled,
} from '@disco/state-management/selectors/business'
import {
  getCorePlan,
  getUsersLimits,
  isBankDraftSubscriber,
} from '@disco/state-management/selectors/user'
/**
 * Checks if team member invitations should be disabled based on plan and quota limits.
 * @param state - The Redux state
 * @returns True if invitations should be disabled, false otherwise
 * @todo Improve legacy plan definition path
 */
export const isDisableInviteTeamMember = (state: State): boolean => {
  // TODO: Improve legacy plan definition path
  const isLegacyPlan = !isFeatureEnabled(state, {
    featureName: SHOWCASES,
  })
  const corePlan = getCorePlan(state)
  const bankDraftSubscriber = isBankDraftSubscriber(state)
  const usersLimits = getUsersLimits(state)
  // trials should have no limits on inviting users.
  const isTrial = getIsTrial(state)
  return (
    !isTrial &&
    (isLegacyPlan || corePlan?.id === '2020-lite' || bankDraftSubscriber) &&
    usersLimits.overQuota
  )
}
/**
 * Gets the appropriate link for the invite modal based on user permissions and quota status.
 * @param state - The Redux state
 * @returns URL path for invite modal (billing update or user invites)
 */
export const getInviteModalLink = (state: State): string => {
  const usersLimits = getUsersLimits(state)
  const canManageInvitations = state.user?.permissions?.includes(
    'can_manage_invitations',
  )
  const disableInviteTeamMember = isDisableInviteTeamMember(state)
  // trials should have no limits on inviting users.
  const isTrial = getIsTrial(state)
  return !isTrial &&
    usersLimits.overQuota &&
    canManageInvitations &&
    !disableInviteTeamMember
    ? '/settings/billing/update-seats-and-tracks'
    : '/settings/users/invites'
}
